// botConfig.js is a file that contains the configuration for each bot.
import GMailIcon from '../assets/appconnect/gmail_icon.png'
import HubspotIcon from '../assets/source/hubspot-logo.png'
import GMailButton from '../assets/account/btn_google_signin_dark_normal_web.png'
import SalesforceIcon from '../assets/source/Salesforce.svg'
import AirtableIcon from '../assets/source/Airtable.svg'
import JiraIcon from '../assets/source/Jira.svg'
import DatabaseIcon from '../assets/source/DatabaseBlack.svg'
import LinkedInIcon from '../assets/source/LinkedIn.svg'
import AttioIcon from '../assets/source/attio.webp'
import GSheetsIcon from '../assets/source/GoogleSheets.svg'
import SharetribeIcon from '../assets/source/Sharetribe.webp'
import PipedriveIcon from '../assets/source/PipedriveIcon.png'
import MondayIcon from '../assets/source/Monday.webp'
import CloseIcon from '../assets/source/close.svg'
import ApolloIcon from '../assets/source/apollo.svg'
import GoogleAnalyticsIcon from '../assets/source/google-analytics.svg'
import AsanaIcon from '../assets/source/asana.webp'
import IntercomIcon from '../assets/source/intercom.webp'
import ShopifyIcon from '../assets/source/shopify.webp'
import MailchimpIcon from '../assets/source/mailchimp.webp'
import CalendlyIcon from '../assets/source/calendly.webp'
import SquareIcon from '../assets/source/square.webp'

const datasourceDefs = [
    {
        name: 'Hubspot',
        icon: HubspotIcon,
        service: 'R17',
        botUID: 'appconnect@scoop-analytics.com', // for now, users must share their hubspot with this Scoop account
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: true, // if true, the user must share their hubspot with the Scoop account
        urlValidation: /^https:\/\/app\.hubspot\.com\/reports-list\/.*$/, // regex to validate the url
        isSnapshotDefault: false,
    },
    {
        name: 'LinkedIn',
        icon: LinkedInIcon,
        service: 'R20',
        botUID: 'appconnect@scoop-analytics.com', // for now, users must share their LinkedIn with this Scoop account
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: true, // if true, the user must share their LinkedIn with the Scoop account
        urlValidation:
            /^https:\/\/www\.linkedin\.com\/campaignmanager\/accounts\/\d+\/campaign-groups.*/, // regex to validate the url
        isSnapshotDefault: false,
    },
    {
        name: 'Gmail',
        icon: GMailIcon,
        service: 'R16',
        button: GMailButton,
        GMAIL_API_URL:
            'https://accounts.google.com/o/oauth2/v2/auth?access_type=offline&scope=https://www.googleapis.com/auth/gmail.readonly%20https://www.googleapis.com/auth/userinfo.email%20https://www.googleapis.com/auth/userinfo.profile&client_id=193840168882-pplhel3cbmmqt33g97h6fqv6msbrvdv2.apps.googleusercontent.com&redirect_uri=REDIRECT_URI&response_type=code&prompt=consent',
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/gmailoauth',
        BOT_API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
    },
    {
        name: 'Salesforce',
        icon: SalesforceIcon,
        service: 'email',
        isSnapshotDefault: false,
    },
    {
        name: 'Airtable',
        icon: AirtableIcon,
        service: 'R18',
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: false, // if true, the user must share their hubspot with the Scoop account
        urlValidation: /^https:\/\/airtable\.com\/.*$/, // regex to validate the url
        isSnapshotDefault: false,
    },
    {
        name: 'Database',
        icon: DatabaseIcon,
        service: 'R19',
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: false, // if true, the user must share their hubspot with the Scoop account
        urlValidation: /^https:\/\/airtable\.com\/.*$/, // regex to validate the url
        isSnapshotDefault: false,
    },
    /*{
        name: 'GoogleDataStudio',
        icon: GoogleDataStudio,
        service: 'R1',
        botUID: 'appconnect@scoop-analytics.com', // for now, users must share their GSheets with this Scoop account
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: true, // if true, the user must share their GSheets with the Scoop account
        urlValidation: /^https:\/.*!/, // regex to validate the url
        isSnapshotDefault: false,
    },*/
    {
        name: 'Jira',
        icon: JiraIcon,
        service: 'R9',
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: false, // if true, the user must share their hubspot with the Scoop account
        urlValidation: /^https:\/\/[^.]+\.atlassian\.net(\/.*)?$/, // regex to validate the url
        isSnapshotDefault: false,
    },
    {
        name: 'Sharetribe',
        icon: SharetribeIcon,
        service: 'R21',
        botUID: 'appconnect@scoop-analytics.com', // for now, users must share their GSheets with this Scoop account
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: true, // if true, the user must share their GSheets with the Scoop account
        urlValidation: /^https:\/\/console\.sharetribe\.com(\/.*)?$/, // regex to validate the url
        isSnapshotDefault: false,
    },
    {
        name: 'Apollo',
        icon: ApolloIcon,
        service: 'R22',
        API_URL: 'https://pig8gecvvk.execute-api.us-west-2.amazonaws.com/corsair/botactions',
        shouldShareWithScoop: false, // if true, the user must share their GSheets with the Scoop account
        urlValidation: /^https:\/\/app\.apollo\.io(\/.*)?$/, // regex to validate the url
        isSnapshotDefault: false,
    },
    {
        name: 'Pipedrive',
        icon: PipedriveIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Attio',
        icon: AttioIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Close',
        icon: CloseIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'GoogleAnalytics',
        icon: GoogleAnalyticsIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Monday',
        icon: MondayIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Asana',
        icon: AsanaIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Intercom',
        icon: IntercomIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Shopify',
        icon: ShopifyIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Calendly',
        icon: CalendlyIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Mailchimp',
        icon: MailchimpIcon,
        isSnapshotDefault: false,
    },
    {
        name: 'Square',
        icon: SquareIcon,
        isSnapshotDefault: false,
    },
]

export default datasourceDefs
